import React from 'react';
import Loadable from '@loadable/component';

import './testimonials.styles.scss';

const Pulse = Loadable(() => import('react-reveal/Pulse'));
const OwlCarousel = Loadable(() => import('react-owl-carousel3'));

const options = {
  loop: true,
  nav: true,
  dots: false,
  autoplayHoverPause: true,
  autoplay: true,
  margin: 30,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    992: {
      items: 2,
    },
  },
};

type Testimonial = {
  author: string;
  occupation: string;
  statement: string;
  photo?: string;
  photoLink?: string;
};
const testimonials: Testimonial[] = [
  {
    author: 'Safina Kala',
    occupation: 'Front line health care worker',
    statement: `It has helped me tremendously with the cost of getting to work, as
                transportation companies have increased the rate due to covid
                distancing restrictions.`,
    // photo: require('../../assets/photos/testimonials/ontario-health-tiny.png'),
    // photoLink: 'https://www.ontariohealth.ca/',
  },
  {
    author: 'Dave',
    occupation: 'Nutcracker Sweet',
    statement: `It's a very simple process, the funny thing is this morning, I left later than I usually do and
                even with the train delay ended up driving by the bus I would
                have normally taken.`,
    // photo: require('../../assets/photos/testimonials/nutcracker.png'),
    // photoLink: 'https://www.nutcrackersweet.com/Gift-Baskets/',
  },
  {
    author: 'Thuy Tien Le',
    occupation: 'St. Joseph’s Health Centre',
    statement: `It was a great experience as I saved lots of time in term of
                commuting to work. I get to work earlier and had more energy as
                I had more sleep.`,
    // photo: require('../../assets/photos/testimonials/st-joseph-tiny.png'),
    // photoLink: 'https://supportstjoes.ca/',
  },
];

const partners = [
  require('../../assets/photos/hopin-partners/bbot.png'),
  require('../../assets/photos/hopin-partners/nma.png'),
  require('../../assets/photos/hopin-partners/dds.png'),
  require('../../assets/photos/hopin-partners/maple-lodge.png'),
  require('../../assets/photos/hopin-partners/nutcracker.png'),
];

const Testimonials: React.FC = () => {
  return (
    <div className="testimonials ptb-100">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">Testimonials</span>
          <h2>Client Feedback</h2>
        </div>

        <Pulse>
          <OwlCarousel
            className="testimonials-slides owl-carousel owl-theme"
            {...options}
          >
            {testimonials.map(
              ({ author, occupation, photo, photoLink, statement }, i) => (
                <div className="single-testimonials-box bg-fafafb" key={i}>
                  <p>{statement}</p>

                  <div className="client-info">
                    <div className="d-flex justify-content-center align-items-center">
                      {photo && photoLink && (
                        <a
                          href={photoLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={photo} alt="features" />
                        </a>
                      )}
                      <div className="title">
                        <h3>{author}</h3>
                        <span>{occupation}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </OwlCarousel>
        </Pulse>

        <div className="container">
          <div className="row align-items-center">
            {partners.map((link, i) => (
              <div className="col-lg-2 col-6 col-sm-4 col-md-4" key={i}>
                <Pulse>
                  <div className="single-partner-item">
                    <img src={link} alt="partner" />
                  </div>
                </Pulse>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
